import kebabCase from "lodash/kebabCase";
import { arrayOfSubscriptionInvoices } from "~/schemas/schema.subscriptionInvoice";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const updateSubscribers = (parentId, _parentType, subscribers) => {
  const parentType = kebabCase(_parentType);
  return {
    types: [
      actionTypes.UPDATE_SUBSCRIBERS_LOADING,
      actionTypes.UPDATE_SUBSCRIBERS_SUCCESS,
      actionTypes.UPDATE_SUBSCRIBERS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscribers/${parentType}/${parentId}`,
        method: `put`,
        body: subscribers,
      }),
    payload: {
      parentId,
      parentType,
      subscribers,
    },
  };
};

export const fetchBrakeDownPrices = () => {
  return {
    types: [
      actionTypes.FETCH_BRAKE_DOWN_PRICE_LOADING,
      actionTypes.FETCH_BRAKE_DOWN_PRICE_SUCCESS,
      actionTypes.FETCH_BRAKE_DOWN_PRICE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/price`,
      }),
  };
};

export const fetchAllInvoices = () => {
  return {
    types: [
      actionTypes.FETCH_ALL_INVOICES_LOADING,
      actionTypes.FETCH_ALL_INVOICES_SUCCESS,
      actionTypes.FETCH_ALL_INVOICES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/invoices`,
      }),
    payload: {
      schema: arrayOfSubscriptionInvoices,
    },
  };
};

export const addSubscriber = (_parentType, parentId, userId) => {
  const parentType = kebabCase(_parentType);
  const types = [
    actionTypes.ADD_SUBSCRIBER_LOADING,
    actionTypes.ADD_SUBSCRIBER_SUCCESS,
    actionTypes.ADD_SUBSCRIBER_ERROR,
  ];
  return {
    types,
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscribers/${parentType}/${parentId}/users/${userId}`,
        method: "post",
      }),
    payload: {
      parentType,
      parentId,
      userId,
    },
  };
};

export const removeSubscriber = (_parentType, parentId, userId) => {
  const parentType = kebabCase(_parentType);
  const types = [
    actionTypes.REMOVE_SUBSCRIBER_LOADING,
    actionTypes.REMOVE_SUBSCRIBER_SUCCESS,
    actionTypes.REMOVE_SUBSCRIBER_ERROR,
  ];
  return {
    types,
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscribers/${parentType}/${parentId}/users/${userId}`,
        method: "delete",
      }),
    payload: {
      parentType,
      parentId,
      userId,
    },
  };
};
